enum Status {
  ALL = 'all',
  OPEN = 'open',
  PREOPEN = 'preOpen',
  REMODEL = 'remodel',
  CLOSED = 'closed',
}

export default Status;
